import { Box, Stack, Typography } from "@mui/material";

import useDetailModal from "src/hooks/useDetailModal";
import { addItemToMyList, deleteItemFromMyList } from "src/redux/slices/myList";
import { useDispatch, useSelector } from "src/redux";
import MyListAddButton from "src/components/MyListAddButton";
import MyListRemoveButton from "src/components/MyListRemoveButton";
import LazyImageWith9Ratio11 from "src/components/LazyImageWith9Ratio11";
import MaxLineText from "src/components/MaxLineText";

export default function RelatedMovieItem({ movie }) {
  const { type, logo, title, id } = movie;
  const dispatch = useDispatch();
  const { myList } = useSelector((state) => state.myList);

  const { setDetailModal } = useDetailModal();

  return (
    <Box>
      <LazyImageWith9Ratio11
        alt={title}
        src={logo}
        onClick={() => {
          setDetailModal(movie);
        }}
      />
      <Stack
        direction="row"
        spacing={2}
        sx={{ width: 1, mt: 1 }}
        alignItems="center"
      >
        <Box sx={{ width: 0.8, pl: 0.5 }}>
          <MaxLineText maxLine={1} variant="subtitle1" text={title} />
          <Typography variant="body2">2022</Typography>
        </Box>
        <Box flexGrow={1} />
        {!myList.includes(id) ? (
          <MyListAddButton
            onClick={() => {
              dispatch(addItemToMyList({ contentId: id, type }));
            }}
          />
        ) : (
          <MyListRemoveButton
            onClick={() => {
              dispatch(deleteItemFromMyList({ id, type }));
            }}
          />
        )}
      </Stack>
    </Box>
  );
}
